export class QueryDBResultResponse {
    'columns';
    'records';
    'nextToken';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "records",
            "baseName": "records",
            "type": "Array<Array<string>>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return QueryDBResultResponse.attributeTypeMap;
    }
    constructor() {
    }
}
